/* philcrozier.com header behaviour — sections/pc-header.liquid. Built 2026-09-28.
   1. --header-height on <html>, kept current. The art shop's Sky Study and About pages position
      with it (it used to come from Dawn's StickyHeader, which this header replaces).
   2. Over the home slideshow the header is transparent; .is-solid turns it white once the slideshow
      has scrolled up under it. The trigger is any element marked data-pc-overlay-header, so a page
      without a slideshow simply never goes transparent.
   3. Dropdowns: open on hover with a mouse, on click/Enter otherwise; one open at a time; Esc and
      clicking elsewhere close them.
   4. The phone menu, with page scroll locked while it is open. */
(function () {
  var header = document.querySelector('[data-pc-header]');
  if (!header) return;
  var root = document.documentElement;

  function setHeight() {
    root.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  setHeight();
  window.addEventListener('resize', setHeight);

  var hero = document.querySelector('[data-pc-overlay-header]');
  if (hero) {
    var ticking = false;
    var update = function () {
      ticking = false;
      header.classList.toggle('is-solid', window.scrollY > hero.offsetHeight - header.offsetHeight - 1);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  var drops = Array.prototype.slice.call(header.querySelectorAll('[data-pc-drop]'));
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function closeDrops(except) {
    drops.forEach(function (d) { if (d !== except) d.open = false; });
  }
  drops.forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) closeDrops(d); });
    if (!canHover) return;
    var timer;
    d.addEventListener('mouseenter', function () { clearTimeout(timer); d.open = true; });
    d.addEventListener('mouseleave', function () { timer = setTimeout(function () { d.open = false; }, 200); });
    // Already open from the hover: a click on the chevron keeps it open instead of snapping it shut. A click on the title is a link, so it goes through.
    d.querySelector('summary').addEventListener('click', function (e) { if (d.open && !e.target.closest('a')) e.preventDefault(); });
  });
  document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeDrops(); });
  // On the home page, clicking "Sessions" scrolls to the Sessions section instead of reloading the page it is already on
  // (Shane, 8 Oct). From any other page the link still goes to the home page.
  var title = header.querySelector('a.pc-nav__title');
  var target = document.getElementById('sessions');
  if (title && target) {
    title.addEventListener('click', function (e) {
      var here = location.pathname.replace(/\/+$/, '') || '/';
      var there = new URL(title.href, location.href).pathname.replace(/\/+$/, '') || '/';
      if (here !== there) return;
      e.preventDefault();
      closeDrops();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }


  var burger = header.querySelector('[data-pc-burger]');
  var menu = document.getElementById('PcMenu');
  function openMenu() {
    menu.hidden = false;
    burger.setAttribute('aria-expanded', 'true');
    header.classList.add('is-menu-open');
    root.classList.add('pc-lock');
  }
  function closeMenu() {
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    burger.setAttribute('aria-expanded', 'false');
    header.classList.remove('is-menu-open');
    root.classList.remove('pc-lock');
  }
  if (burger && menu) {
    burger.addEventListener('click', function () { if (menu.hidden) openMenu(); else closeMenu(); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) closeMenu(); });
    window.matchMedia('(min-width: 1100px)').addEventListener('change', function (e) { if (e.matches) closeMenu(); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrops();
    if (menu && !menu.hidden) { closeMenu(); burger.focus(); }
  });
})();
